import { render, staticRenderFns } from "./trocarAtendente.vue?vue&type=template&id=75810cf2"
import script from "./trocarAtendente.ts?vue&type=script&lang=js&external"
export * from "./trocarAtendente.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75810cf2')) {
      api.createRecord('75810cf2', component.options)
    } else {
      api.reload('75810cf2', component.options)
    }
    module.hot.accept("./trocarAtendente.vue?vue&type=template&id=75810cf2", function () {
      api.rerender('75810cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/atendimentos/trocarAtendente/trocarAtendente.vue"
export default component.exports